// Ads are served by Google Ad Manager (see php/gam.php). The legacy "annonser" CPT ad loaders
// (AdLoader, TakeOverAdLoader) were removed; only the shared config used by mb-generic.js remains.
var jjAdManager = {
    Config: {
        GetServiceUrl: function () {
            if (window.location.hostname === 'stage.jaktojagare.se') {
                return 'https://stage.jaktojagare.se/wp-json/';
            } else if (window.location.hostname === 'dev.jaktojagare.se') {
                return 'https://dev.jaktojagare.se/wp-json/';
            } else {
                return 'https://www.jaktojagare.se/wp-json/';
            }
        },
        GetMobileBreakpoint: function () {
            return 1024;
        },
    },
};
